export const downloadAppFormContentsEn = {
  header: `Welcome to Awair`,
  headerDescription: 'Now that your Awair account has been created, download the Awair app below to get started.',
  downloadDescription: 'Download the Awair App',
  contactUsDescription: 'If you have any questions, please reach out to us at',
}

export const downloadAppFormContentsKr = {
  header: '가입이 완료되었습니다',
  headerDescription: '이제 어웨어 앱에서 로그인하고 실내공기를 눈으로 확인해보세요. 아래 링크를 통해 어웨어 앱을 다운받을 수 있습니다.',
  downloadDescription: '어웨어 앱 다운받기',
  contactUsDescription: '어웨어 제품/이용 문의는 이메일로 연락주세요. ',
}